import { brightpathTheme } from '@youscience/theme';

export * from './colors';

export const collegesTheme = brightpathTheme;
